import { Component, input, output } from '@angular/core';

@Component({
  standalone: true,
  selector: 'lib-user-menu-trigger',
  template: `
    <button
      type="button"
      (click)="toggle.emit($event)"
      class="flex items-center space-x-3 text-gray-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 focus:ring-offset-gray-900 rounded-md p-1 transition-colors duration-200"
      [attr.aria-expanded]="isOpen()"
      aria-haspopup="menu"
    >
      @if (showInitials()) {
      <div
        class="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center text-white text-sm font-medium shadow-md"
      >
        {{ userInitials() }}
      </div>
      }

      <span class="hidden 2xl:block text-sm font-medium">
        {{ userFullName() }}
      </span>

      <svg
        class="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
        />
      </svg>

      <svg
        class="w-4 h-4 transition-transform duration-200"
        [class.rotate-180]="isOpen()"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </button>
  `,
})
export class UserMenuTriggerComponent {
  userFullName = input('');
  userInitials = input('U');
  showInitials = input(false);
  isOpen = input(false);

  toggle = output<Event>();
}
